export function isTwoPrimitiveArraysEqual<T extends (string | number)[]>(array1: T, array2: T) {
	return array1.length === array2.length && array1.every((value) => array2.includes(value));
}
